export default {
    projects: [
        {
            id: 0,
            hidden: false,
            title: "Bread Financial - Account Center",
            name: "bread financial - account center",
            link_name: "Account Center",
            slug: "bread-account-center",
            gradient: "bread-account-center",
            lead: "Manage your credit card with Account Center. Make a payment, view your transactions and statements, redeem rewards, lock your card, and manage your profile all within your Account Center.",
            banner: {
                title: "Bread Financial - Account Center",
                text: "Manage your credit card with Account Center. Make a payment, view your transactions and statements, redeem rewards, lock your card, and manage your profile all within your Account Center. ",
                background: 'bread-account-center-banner'
            },

            sections: [
                {
                    title: "Final Product",
                    intro: "I've lead white label projects (200+ client websites) from idea to launch on Account Center. This is a deep dive into just one of those projects; credit card activation.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-blue",
                        text: "View Account Center",
                        url: "https://d.comenity.net/ac/nflvisa/public/home"
                    },
                    image: {
                        url: "/featured-projects/final/bread-account-center.png",
                        alt: "Bread Account Center - Final Product",
                        classes: "bread image-wrap"
                    }
                },
                {
                    title: "The Problem",
                    intro: "The Problem: How might we make card activation faster to increase spend on credit cards while also encouraging registration, paperless, and Account Assure.",
                    deliverables: ['Problem Statement', 'Low Fidelity Designs', 'Competitive Analysis', 'Prototypes', 'Flows', 'User Testing', 'Scenarios', 'High Fidelity Designs']
                },
                {
                    title: "Research",
                    intro: "I researched competitive examples to see how other businesses approached and solved the problem.",
                    image: {
                        url: "/featured-projects/research/bread-account-center-research.png",
                        alt: "Bread Account Center - Research"
                    }
                },
                {
                    title: "User Scenarios",
                    intro: "After research and competitive patterning, I created all the possible user scenarios for credit card activation. Including detail around what the user sees and does on each step. This helped communicate to business partners involved and help keep everyone aligned on the solution.",
                    image: {
                        url: "/featured-projects/scenarios/bread-account-center-scenarios.png",
                        alt: "Bread Account Center - User Scenarios",
                    }
                },
                {
                    title: "Flows",
                    intro: "I created a high flows to make sure all pages and processes were taken into account. Flows are an easy way to help communicate with business partners about all the moving parts of the project.",
                    image: {
                        url: '/featured-projects/flows/bread-account-center-flows.png',
                        alt: "Bread Account Center - User Flow"
                    }
                },
                {
                    title: "Wireframes & Prototypes",
                    intro: "After creating a flow I was able to start wireframes of the new activation experience. I looked into splitting the process into multiple steps instead of overwhelming the user with too much information. After creating the wireframes from project requirements, I was able to meet with stakeholders and get sign off to move forward with a prototype.",
                    image: {
                        url: "/featured-projects/wireframes/bread-account-center/wireframe.png",
                        alt: "Bread Account Center - Wireframe"
                    }
                },
                {
                    title: "High Fidelity Design",
                    intro: "We were fortunate enough to partner with Razorfish, one of the best digital agencies in the world to help with the visual design. It was interesting to see their ideas and creativity on screens we’ve redesigned internally in the past.",
                    image: {
                        url: "/featured-projects/fidelity/bread-account-center-fidelity.png",
                        alt: "Bread Account Center - High Fidelity Design"
                    }
                },
                {
                    title: "Usability & Interviews",
                    intro: "Having a real person test a user experience are always 100x more valuable than any assumptions. Most of the feedback from this usability study wouldn't have stopped the user from their primary task, but it gave me enough feedback to tweak wireframes, designs, and prototypes to avoid the user from having any doubts or questions.",
                    image: {
                        url: "/featured-projects/usability/bread-account-center-usability.png",
                        alt: "Bread Account Center - Usability & Interviews"
                    }
                },
                {
                    title: "Deliver",
                    intro: "Lastly, I created UX Specification to give our development team documentation to make it clear of all the user experience decisions. These requirements included accessibility WCAG 2.1.",
                    image: {
                        url: "/featured-projects/deliver/bread-account-center-deliver.png",
                        alt: "Bread Account Center - Deliver"
                    }
                },
                {
                    title: "Visual Design & Launch",
                    intro: "The design was created in Figma to help with velocity, speed, and collaboration for the design and development.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-blue",
                        text: "View Account Center",
                        url: "https://d.comenity.net/ac/nflvisa/public/home"
                    },
                    image: {
                        url: "/featured-projects/launch/bread-account-center.png",
                        alt: "Bread Account Center - Visual Design & Launch",
                        classes: "bread image-wrap"
                    }
                }
            ]
        },
        {
            id: 1,
            hidden: false,
            title: "Bread Financial - EasyPay",
            name: "bread financial - easypay",
            link_name: "EasyPay",
            slug: "bread-easypay",
            gradient: "bread-easypay",
            lead: "Pay faster without signing in. Comenity's EasyPay is a great way to pay your bill in a hurry.",
            banner: {
                title: "Bread Financial - EasyPay",
                text: "Pay Faster Without Signing In. Comenity’s EasyPay is a great way to pay your bill in a hurry.",
                background: 'bread-easypay-banner'
            },

            sections: [
                {
                    title: "Final Product",
                    intro: "Here's the end result of all of the hard work that went into the project. Keep scrolling if you want to learn about all the work that went into the process.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-blue",
                        text: "View EasyPay",
                        url: "https://d.comenity.net/easypay/ikeavisa/"
                    },
                    image: {
                        url: "/featured-projects/final/bread-easypay.png",
                        alt: "Bread EasyPay - Final Product",
                        classes: "bread image-wrap"
                    }
                },
                {
                    title: "The Problem",
                    intro: "The Problem: How might we make digital payments more convenient for non-digitalists (and digitalists who can’t sign in) to increase digital payments by cardmembers.",
                    deliverables: ['Problem Statement', 'Low Fidelity Designs', 'Competitive Analysis', 'Prototypes', 'Personas', 'Interviews', 'Flows', 'User Testing', 'Scenarios', 'High Fidelity Designs']
                },
                {
                    title: "Personas",
                    intro: "To understand our audience for EasyPay, I created personas to match who we’re designing for. Agnes is our non-digitalist that pays via check, Miles is our digitalist that is always on time with his payments, but has issues signing in, and Justine is our digitalist that is going through collections.",
                    images: [
                        {
                            url: '/featured-projects/personas/bread/agnes.png',
                            alt: 'Bread - Agnes'
                        },
                        {
                            url: '/featured-projects/personas/bread/miles.png',
                            alt: 'Bread - Miles'
                        },
                        {
                            url: '/featured-projects/personas/bread/justine.png',
                            alt: 'Bread - Justine'
                        },
                    ]
                },
                {
                    title: "Research",
                    intro: "I created user flows for a first time user to make sure all personas had an easy time with their first experience.",
                    image: {
                        url: "/featured-projects/research/bread-easypay-research.png",
                        alt: "Bread EasyPay - Research",
                    }
                },
                {
                    title: "User Scenarios",
                    intro: "I created scenarios and for the different users that will be using EasyPay.",
                    image: {
                        url: "/featured-projects/scenarios/bread-easypay-scenarios.png",
                        alt: "Bread EasyPay - Scenarios",
                    }
                },
                {
                    title: "Flows",
                    intro: "Scenarios and flows are an easy way to help communicate with business partners about all the moving parts of a project.",
                    image: {
                        url: '/featured-projects/flows/bread-flows.png',
                        alt: "Bread EasyPay - User Flow"
                    }
                },
                {
                    title: "Concept",
                    intro: "An example of a design thinking exercise I led — we split into 3 teams and sketched how we envisioned EasyPay to work.",
                    image: {
                        url: "/featured-projects/concept/bread-concept.png",
                        alt: "Bread EasyPay - Concept"
                    }
                },
                {
                    title: "Wireframes & Prototypes",
                    intro: "Using wireframes and low fidelity design I can start to iterate on our problem statement to solve the businesses goals. Prototypes are created to help with user testing. They're meant to mimic the real experience a user will see in production.",
                    image: {
                        url: "/featured-projects/wireframes/bread/wireframe.png",
                        alt: "Bread EasyPay - Wireframes & Prototypes"
                    }
                },
                {
                    title: "High Fidelity Design",
                    intro: "Using the sketches and wireframes as my guide, I then can start on visual design to show polished designs of the product.",
                    image: {
                        url: "/featured-projects/fidelity/bread-easypay-fidelity.png",
                        alt: "Bread EasyPay - High Fidelity Design"
                    }
                },
                {
                    title: "Usability & Interviews",
                    intro: "I moderated user testing to interview users about why they pay via mail and phone and then watched them use the prototype to see obstacles and challenges they experienced.",
                    image: {
                        url: "/featured-projects/usability/bread-easypay-usability.png",
                        alt: "Bread EasyPay - Usability & Interviews"
                    }
                },
                {
                    title: "Deliver",
                    intro: "UX Specs are created to document every decision for the agile team to absorb. These requirements included accessibility WCAG 2.1.",
                    image: {
                        url: "/featured-projects/deliver/bread-easypay-deliver.png",
                        alt: "Bread EasyPay - Deliver"
                    }
                },
                {
                    title: "Support",
                    intro: "Teaming up with the agile team to see if anything shakes out while in development before the install.",
                    image: {
                        url: "/featured-projects/support/bread-support.png",
                        alt: "Bread EasyPay - Support"
                    }
                },
                {
                    title: "Pivot",
                    intro: "Leadership wanted to push this as a new and exciting digital capability that they can use for press releases. We took it back to the drawing board to see if we could make it more innovative and new.",
                    image: {
                        url: "/featured-projects/pivot/bread-pivot.png",
                        alt: "Bread EasyPay - Pivot"
                    }
                },
                {
                    title: "Visual Design & Launch",
                    intro: "The design was created in Figma to help with velocity, speed, and collaboration for the design and development.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-blue",
                        text: "View EasyPay",
                        url: "https://d.comenity.net/easypay/ikeavisa/"
                    },
                    image: {
                        url: "/featured-projects/launch/bread-easypay.png",
                        alt: "Bread EasyPay - Visual Design & Launch",
                        classes: "bread image-wrap"
                    }
                }
            ]
        },
        {
            id: 2,
            title: "Lamden - Blockchain",
            name: "lamden",
            link_name: "Lamden",
            slug: "lamden",
            gradient: "lamden",
            lead: "Lamden is the performant Python-based blockchain platform that makes using and creating the next generation of dApps easy for everyone.",
            banner: {
                title: "Lamden - Blockchain",
                text: "In 2018 I started following Lamden. What began as curiosity about blockchain bloomed into a relationship with the team and lots of freelance opportunities.",
                background: 'lamden-banner'
            },

            sections: [
                {
                    title: "Final Product",
                    intro: "Here's the end result of all of the hard work that went into the project. Keep scrolling if you want to learn about all the work that went into the process.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-purple",
                        text: "View Crome Extension",
                        url: "https://chrome.google.com/webstore/detail/lamden-vault-browser-exte/fhfffofbcgbjjojdnpcfompojdjjhdim"

                    },
                    image: {
                        url: "/featured-projects/final/lamden.png",
                        alt: "Lamden",
                        classes: "lamden"
                    }
                },
                {
                    title: "The Problem",
                    intro: "How might we make a crypto wallet more convenient for everyone so that we become the only crypto wallet you ever need to use to increase the adoption of Lamden.",
                    deliverables: ['Problem Statement', 'Low Fidelity Designs', 'Competitive Analysis', 'Prototypes', 'Personas', 'Interviews', 'Flows', 'User Testing', 'Scenarios', 'High Fidelity Designs']
                },
                {
                    title: "Personas",
                    intro: "I created three personas to fit the target demographic. We need a business professional, an investor, and a developer to fit these objectives.",
                    images: [
                        {
                            url: '/featured-projects/personas/lamden/bob.png',
                            alt: 'Lamden - Bob',
                            classes: 'lamden-border'
                        },
                        {
                            url: '/featured-projects/personas/lamden/ace.png',
                            alt: 'Lamden - Ace',
                            classes: 'lamden-border'
                        },
                        {
                            url: '/featured-projects/personas/lamden/max.png',
                            alt: 'Lamden - Max',
                            classes: 'lamden-border'
                        },
                    ]
                },
                {
                    title: "User Scenarios",
                    intro: "After research and competitive patterning, I created all the possible user scenarios Bob, Ace, and Max would need to accomplish in the wallet.",
                    images: [
                        {
                            url: '/featured-projects/scenarios/scenario-bob.png',
                            alt: 'Lamden - Bob Scenario'
                        },
                        {
                            url: '/featured-projects/scenarios/scenario-ace.png',
                            alt: 'Lamden - Ace Scenario'
                        },
                        {
                            url: '/featured-projects/scenarios/scenario-max.png',
                            alt: 'Lamden - Max Scenario'
                        },
                    ]
                },
                {
                    title: "Flows",
                    intro: "I created user flows for a first time user to make sure all personas had an easy time with their first experience.",
                    image: {
                        url: '/featured-projects/flows/lamden-flows.png',
                        alt: "Lamden - User Flow"
                    }
                },
                {
                    title: "Wireframes & Prototypes",
                    intro: "After creating a flow I was able to start wireframes of the new experience. Since cryptocurrency and browser extensions are new to most users, I wanted to make sure I was guiding them each step of the way and gave them paths if they were confused or lost. I created a prototype of the wireframes to share with the team to get feedback. Here's the prototype in Axure. Fast iterations are very essential to this process.",
                    images: [
                        {
                            url: '/featured-projects/wireframes/lamden/onboarding.png',
                            alt: 'Lamden - Onboarding',
                            classes: 'lamden-border'
                        },
                        {
                            url: '/featured-projects/wireframes/lamden/prototype.png',
                            alt: 'Lamden - Prototype',
                            classes: 'lamden-border'
                        }
                    ]
                },
                {
                    title: "Usability & Interviews",
                    intro: "Interviews were done over Zoom and Skype while screen sharing and usability was done using usertesting.com. All of the feedback went into further iterations of the prototype."
                },
                {
                    title: "Final Product",
                    intro: "The design was created in Figma to help with velocity, speed, and collaboration for the design and development.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-purple",
                        text: "View Crome Extension",
                        url: "https://chrome.google.com/webstore/detail/lamden-vault-browser-exte/fhfffofbcgbjjojdnpcfompojdjjhdim"
                    },
                    image: {
                        url: "/featured-projects/final/lamden.png",
                        alt: "Lamden",
                        classes: "lamden image-wrap"
                    }
                },
                {
                    title: "More Work",
                    intro: "The team was so excited with all the work that was done on the Lamden wallet that I was given the contract for a redesigned website. Check out their new website!",
                    button: {
                        classes: "btn btn-gradient btn-gradient-purple",
                        text: "View Website",
                        url: "https://lamden.io/"
                    },
                    workImages: [
                        {
                            url: '/featured-projects/work/desktop.png',
                            alt: 'Lamden - Desktop'
                        },
                        {
                            url: '/featured-projects/work/mobile.png',
                            alt: 'Lamden - Mobile'
                        }
                    ],
                }
            ],
        },
        {
            id: 3,
            hidden: false,
            title: "LambDoge - Comic NFTs",
            name: "lambdoge",
            link_name: "LambDoge",
            slug: "lambdoge",
            gradient: "lambdoge",
            lead: "A comic book series that is written by, voted on and enjoyed by the LambDoge community.",
            banner: {
                title: "LambDoge - Comic NFTs",
                text: "A comic book series that is written by, voted on and enjoyed by the LambDoge community.",
                background: 'lambdoge-banner',
            },

            sections: [
                {
                    title: "Final Product",
                    intro: "Here's the end result of all of the hard work that went into the project. Keep scrolling if you want to learn about all the work that went into the process.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-gold",
                        text: "View Website",
                        url: "https://lambdoge.com/"
                    },
                    image: {
                        url: "/featured-projects/final/lambdoge.png",
                        alt: "Lambdoge",
                        classes: "lambdoge"
                    }
                },
                {
                    title: "The Problem",
                    intro: "How might we make a comic NFT so that everyone reads the comic, votes on the story, and buys the LambDoge NFT.",
                    deliverables: ['Problem Statement', 'Low Fidelity Designs', 'Competitive Analysis', 'High Fidelity Designs']
                },
                {
                    title: "Competitive Examples",
                    intro: "Designing for the comic book aesthetic was new to me. After meeting with the business stakeholder, we talked about a few websites we liked and found inspiration that was in-line with what we wanted.",
                    images: [
                        {
                            url: '/featured-projects/examples/lambdoge/dragon-kart.png',
                            alt: 'Lambdoge - Dragon Kart',
                            classes: 'lambdoge-border'
                        },
                        {
                            url: '/featured-projects/examples/lambdoge/aurory-project.png',
                            alt: 'Lambdoge - Aurory Project',
                            classes: 'lambdoge-border'
                        },
                        {
                            url: '/featured-projects/examples/lambdoge/block-dueler.png',
                            alt: 'Lambdoge - Block Dueler',
                            classes: 'lambdoge-border'
                        },
                    ]
                },
                {
                    title: "Fonts, Colors & Buttons",
                    intro: "I was able to flex my visual design muscles more than I usually do to lean more into the fun aspect of this projects",
                    image: {
                        url: '/featured-projects/fonts/lambdoge.png',
                        alt: "Lambdoge - Fonts, Colors & Buttons"
                    }
                },
                {
                    title: "Stickers",
                    intro: "I was able to use the stickers that were already created for this project to keep it really fun and friendly.",
                    image: {
                        url: '/featured-projects/stickers/lambdoge.png',
                        alt: "Lambdoge - Stickers"
                    }
                },
                {
                    title: "Launch",
                    intro: "The design was created in Figma to help with velocity, speed, and collaboration for the design and development.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-gold",
                        text: "View Website",
                        url: "https://lambdoge.com/"
                    },
                    image: {
                        url: "/featured-projects/launch/lambdoge.png",
                        alt: "Lambdoge - Launch",
                        classes: "lambdoge"
                    }
                }
            ]
        },
        {
            id: 4,
            hidden: false,
            title: "Nebula - DeFi",
            link_name: "Nebula",
            name: "nebula",
            slug: "nebula",
            gradient: "nebula",
            testImg: "shaq.png",
            lead: "Helps bring new projects to life by removing barriers to development, connecting projects and users, and rewarding contributors.",
            banner: {
                title: "Nebula - DeFi",
                text: "Helps bring new projects to life by removing barriers to development, connecting projects and users, and rewarding contributors",
                background: 'nebula-banner',
            },

            sections: [
                {
                    title: "Final Product",
                    intro: "Here's the end result of all of the hard work that went into the project. Keep scrolling if you want to learn about all the work that went into the process.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-pink",
                        text: "View dApp",
                        url: "https://nebulamden.finance/"
                    },
                    image: {
                        url: "/featured-projects/final/nebula.png",
                        alt: "Nebula",
                        classes: "nebula"
                    }
                },
                {
                    title: "The Problem",
                    intro: "How might we allow users to stake their cryptocurrency so that they can earn interest?",
                    deliverables: ['Problem Statement', 'Low Fidelity Designs', 'Competitive Analysis', 'High Fidelity Designs']
                },
                {
                    title: "Competitive Examples",
                    intro: "The project stakeholder and I looked at a few examples to understand how we could this competitively. We looked at how others were using staking, liquidity, and receiving yields.",
                    images: [
                        {
                            url: '/featured-projects/examples/nebula/farms.png',
                            alt: 'Nebula - Farms',
                            classes: 'nebula'
                        },
                        {
                            url: '/featured-projects/examples/nebula/staking.png',
                            alt: 'Nebula - Staking',
                            classes: 'nebula'
                        },
                        {
                            url: '/featured-projects/examples/nebula/wtf.png',
                            alt: 'Nebula - WTF',
                            classes: 'nebula'
                        },
                    ]
                },
                {
                    title: "Fonts, Colors & Buttons",
                    intro: "We landed on a space theme with dark colors and bright pinks to pop against the dark background. I really enjoy how fun, but professional this feels.",
                    image: {
                        url: '/featured-projects/fonts/nebula.png',
                        alt: "Nebula - Fonts, Colors & Buttons",
                        classes: 'nebula'
                    }
                },
                {
                    title: "Launch",
                    intro: "The design was created in Figma to help with velocity, speed, and collaboration for the design and development.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-pink",
                        text: "View dApp",
                        url: "https://nebulamden.finance/"
                    },
                    image: {
                        url: "/featured-projects/launch/nebula.png",
                        alt: "Nebula",
                        classes: "nebula"
                    }
                },
            ]
        },
        {
            id: 5,
            hidden: true,
            title: "Versapay - Operations Portal",
            name: "versapay - operations portal",
            link_name: "Versapay",
            slug: "versapay",
            gradient: "",
            lead: "An internal platform designed to empower Versapay teams to operate more efficiently across critical stages of the customer lifecycle.",
            banner: {
                title: "Versapay - Operations Portal",
                text: "An internal platform designed to empower Versapay teams to operate more efficiently across critical stages of the customer lifecycle.",
                background: "versapay-banner"
            },

            sections: [
                {
                    title: "Overview",
                    description_list: [
                        {
                            term: "Project Team: ",
                            details: "1 Product Designer (me), 2 Product Managers, 9 QA & Engineers"
                        },
                        {
                            term: "Timeline: ",
                            details: "3 year+ project"
                        },
                        {
                            term: "Impact: ",
                            details: "Own end to end experience, reduce manual internal processes, increase speed to first payment with our customers."
                        },
                    ],
                    stacked_images: [
                        {
                            url: '/featured-projects/versapay/overview/versapay-overview-1.png',
                            alt: 'versapay overview 1'
                        },
                        {
                            url: '/featured-projects/versapay/overview/versapay-overview-2.png',
                            alt: 'versapay overview 2'
                        },
                        {
                            url: '/featured-projects/versapay/overview/versapay-overview-3.png',
                            alt: 'versapay overview 3'
                        },
                        {
                            url: '/featured-projects/versapay/overview/versapay-overview-4.png',
                            alt: 'versapay overview 4'
                        },
                        {
                            url: '/featured-projects/versapay/overview/versapay-overview-5.png',
                            alt: 'versapay overview 5'
                        },
                        {
                            url: '/featured-projects/versapay/overview/versapay-overview-6.png',
                            alt: 'versapay overview 6'
                        },
                        
                    ]
                },
                {
                    title: "The Problem",
                    description_list: [
                        {
                            term: "The Problem: ",
                            details: "Rapid growth led Versapay to rely on third-party vendors to fill critical gaps. After a deal was closed, clients often waited months to access the solution they were sold—creating friction, delays, and a poor first impression. We needed to dramatically accelerate this post-sale experience."
                        },
                        {
                            term: "*2-3 months spent in underwriting, implementations, and product support.",
                            classes: "top-1"
                        },
                        {
                            term: "Opportunity: ",
                            details: "How might we eliminate third-party dependencies, take full ownership of the end-to-end experience, reduce manual processes, and improve time to first payment?",
                            classes: "top-1"
                        },
                        {
                            term: "Outcome Goal: ",
                            details: "Enable the business to move faster and ensure clients realize value from the product as quickly as possible after purchase.",
                            classes: "top-1"
                        },
                        {
                            term: "*2-3 weeks spent in underwriting, implementations, and product support.",
                            classes: "top-1"
                        }
                    ],
                },
                {
                    title: "Design Thinking + Competitive",
                    intro: "Facilitated design thinking workshops to uncover core user needs and define the foundation of the solution. Conducted research on comparable portals to align stakeholders around a clear vision for how our platform should look, feel, and function.",
                    stacked_images: [
                        {
                            url: '/featured-projects/versapay/design/versapay-design-1.png',
                            alt: 'versapay design 1'
                        },
                        {
                            url: '/featured-projects/versapay/design/versapay-design-2.png',
                            alt: 'versapay design 2'
                        },  
                    ]
                },
                {
                    title: "Workshops + Jobs To Be Done",
                    intro: "Ran a Jobs to Be Done workshop to uncover every role touching the sales lifecycle and clarify the key outcomes each is responsible for delivering.",
                    stacked_images: [
                        {
                            url: '/featured-projects/versapay/workshops/versapay-workshops-1.png',
                            alt: 'versapay workshops 1'
                        }
                    ]
                },
                {
                    title: "Challenges",
                    description_list: [
                        {
                            details: "While we had a long-term vision captured in a three-year white paper, there was no clear definition of phased requirements or prioritization for where to start. This created ambiguity around scope, sequencing, and what an initial release should include."
                        },
                        {
                            details: "We also faced foundational design decisions early on—whether to extend the existing design system or establish a new one tailored to the Operations Portal. Regardless of direction, there were no established patterns or templates to follow, meaning every interaction and workflow had to be defined from scratch.",
                            classes: "top-1"
                        },
                        {
                            details: "As the product evolved, we continuously iterated on scope, often scaling back functionality to define a focused and viable MVP. This required balancing long-term vision with immediate business needs and delivery constraints.",
                            classes: "top-1"
                        },
                    ]
                },
                {
                    title: "Interviews and Usability",
                    intro: "Testing with real users proved far more valuable than relying on assumptions. While most usability issues didn’t block task completion, the feedback revealed moments of hesitation and uncertainty. These insights allowed me to refine designs, and prototypes to create a more confident and seamless experience.",
                    stacked_images: [
                        {
                            url: '/featured-projects/versapay/interviews/versapay-interviews-1.png',
                            alt: 'versapay interviews 1'
                        },
                        {
                            url: '/featured-projects/versapay/interviews/versapay-interviews-2.png',
                            alt: 'versapay interviews 2'
                        }
                    ]
                },
                {
                    title: "Delivery",
                    intro: "Used Figma to clearly communicate design readiness for development, ensuring alignment across teams. Partnered closely with product and engineering in team discussions to walk through user stories and review impacted designs. Added annotations and expanded flows where needed to ensure requirements were fully captured. This was a highly collaborative, cross-functional effort.",
                    stacked_images: [
                        {
                            url: '/featured-projects/versapay/delivery/versapay-delivery-1.png',
                            alt: 'versapay delivery 1'
                        }
                    ]
                },
            ]
        },
        {
            id: 6,
            hidden: true,
            title: "Blender - dApp",
            name: "blender",
            link_name: "Blender",
            slug: "blender",
            gradient: "blender",
            testImg: "shaq.png",
            lead: "Blender is a smart contract on Lamden that makes it possible to send transactions anonymously.",
            banner_text: "Blender is a smart contract on Lamden that makes it possible to send transactions anonymously — your transfer address will never know where it originated.",
            banner: {
                title: "Blender - dApp",
                text: "Blender is a smart contract on Lamden that makes it possible to send transactions anonymously — your transfer address will never know where it originated.",
                background: 'blender-banner',
            },

            sections: [
                {
                    title: "Final Product",
                    intro: "Here's the end result of all of the hard work that went into the project. Keep scrolling if you want to learn about all the work that went into the process.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-green",
                        text: "Not Yet Released",
                        url: ""
                    },
                    image: {
                        url: "/featured-projects/final/blender.png",
                        alt: "Blender",
                        classes: "blender"
                    }
                },
                {
                    title: "The Problem",
                    intro: "How might we allow users to send transactions anonymously so that they can get a sense of privacy on the blockchain.",
                    deliverables: ['Problem Statement', 'Low Fidelity Designs', 'Competitive Analysis', 'High Fidelity Designs']
                },
                {
                    title: "Wireframes",
                    intro: "This was a project that started with few requirements and direction. To save myself time and to move fast, I created wireframes to make sure the project stakeholder could give approval on the idea and direction.",
                    images: [
                        {
                            url: '/featured-projects/wireframes/blender/deposit.png',
                            alt: 'Blender - Deposit',
                            classes: 'blender'
                        },
                        {
                            url: '/featured-projects/wireframes/blender/withdraw.png',
                            alt: 'Blender - Withdraw',
                            classes: 'blender'
                        },
                        {
                            url: '/featured-projects/wireframes/blender/confirm.png',
                            alt: 'Blender - Confirm',
                            classes: 'blender'
                        },
                    ]
                },
                {
                    title: "Fonts, Colors & Buttons",
                    intro: "I landed on a “DOS Mode” theme with dark colors and a bright green to give this a science fiction vibe.",
                    image: {
                        url: '/featured-projects/fonts/blender.png',
                        alt: "Blender - Fonts, Colors & Buttons",
                        classes: 'blender'
                    }
                },
                {
                    title: "Launch",
                    intro: "The design was created in Figma to help with velocity, speed, and collaboration for the design and development.",
                    button: {
                        classes: "btn btn-gradient btn-gradient-green",
                        text: "Not Yet Released",
                        url: ""
                    },
                    image: {
                        url: "/featured-projects/launch/blender.png",
                        alt: "Blender",
                        classes: "blender"
                    }
                },
            ],
        }
    ],
    process: [
        {
            title: "Understand",
            text: "Learn the problem you're trying to solve through conversation and research.",
            classes: "blue-gradient-card"
        },
        {
            title: "AI",
            text: "Partnered with LLMs to accelerate research, streamline workflows, and iterate more rapidly.",
            classes: "pink-gradient-card"
        },
        {
            title: "Design",
            text: "Turn your wireframes into pixel perfect visuals to capture the look and feel you want to convey.",
            classes: "gold-gradient-card"
        },
        {
            title: "Prototype",
            text: "Bring your idea to life that's usable and functional to navigate through the experience.",
            classes: "lavender-gradient-card"
        },
        {
            title: "User Test",
            text: "Watch users explore your products and features to hear their feedback and learn from their behavior.",
            classes: "green-gradient-card"
        },
        {
            title: "Learn",
            text: "Iterate until you have real data to show your product or feature solves the problem you were trying to solve.",
            classes: "blue-gradient-card"
        }
    ],
    process_intro: "My job is to bring your vision to light. This starts with an understanding of your wants and needs. From there, I design and prototype to match the goal of the project, deliver a high-quality and user tested product, and continually learn from the data to ensure a positive result.",
    about: [
        {
            title: "I'm Andy",
            text: "My passion as a seasoned product designer has led to designing and building products and features of all sizes with a specialty in fintech. Through collaboration with key stakeholders I have helped businesses turn their ideas into intuitive, customer-first designs that deliver value. I am relentless in the goal of adding value to any product."
        },
        {
            title: "What I can do for you",
            text: "Whether you’re ready to get that great idea off the ground or want to build on an established product, I can help get you there. My sweet spot is turning complex problems into simple solutions that work for both you and your customers."
        }
    ],
    social_links: [
        { name: 'Telegram', icon: 'telegram.svg', href: 'https://t.me/uxandy' },
        { name: 'LinkedIn', icon: 'linkedin.svg', href: 'https://www.linkedin.com/in/andyphil' },
        { name: 'Discord', icon: 'discord.svg', href: 'https://discordapp.com/users/352629071370256384'},
        { name: 'Twitter', icon: 'twitter.svg', href: 'https://twitter.com/uxandyphil' }
    ]
}
